import React from 'react';

function VideoMessage({ src }) {
  return (
    <video
      controls
      className="rounded"
      style={{ maxWidth: '300px', maxHeight: '300px' }}
    >
      <source src={"" + src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
}

export default VideoMessage;
